import * as React from 'react'
import { Component } from 'react'
import { HeaderLogo } from '../component/HeaderLogo'
import Footer from '../component/footer'

export default class CompletedInfo extends Component<[], []>
{
    render() {
    return (
        <div id="visual-portal-wrapper" className="clearfix">
        <HeaderLogo/>
     
        <div id="portal-columns" className="row">
            <div id="portal-columns-content" className="container">
                <h1>IMC Krems online application system</h1>
                <p className="description">       
                <strong>Your application is already completed!</strong></p>
                <p className="discreet">I you have any questions, please feel free to reach out to the IMC Transnational Degree Programme Admissions Team at <a href="mailto:admission@imc.ac.at">admission@imc.ac.at</a></p>
                
            </div>
        </div>
        <Footer />
    </div>
        
    );
    }
}